/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import { Container } from 'flux/utils';
import Chat from 'entities/Chat';
import ChatStore from 'chat/stores/ChatStore';
import ConversationView from 'chat/components/ConversationView.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import { StreamSectionList } from 'chat/components/StreamSectionList';
import View from 'components/View.jsx';
import Group from 'entities/Group';
import { rootGroup } from 'entities/RootGroup';

import './styles/RecentMessages.scss';

class RecentMessages extends React.Component<{}, $FlowFixMeState> {
  state = {
    selectedChat: RecentMessages.getSelectedChat(),
  };

  static childContextTypes = {
    chatSelectionAction: PropTypes.string,
    group: PropTypes.instanceOf(Group),
  };

  static getSelectedChat(): ?Chat {
    return ChatStore.getCurrentChat() || ChatStore.getChats(rootGroup).first();
  }

  static getStores() {
    return [ChatStore];
  }

  static calculateState() {
    return {
      selectedChat: RecentMessages.getSelectedChat(),
    };
  }

  getChildContext() {
    return {
      chatSelectionAction: 'store',
      group: rootGroup,
    };
  }

  render() {
    if (!this.state.selectedChat) {
      return <LoadingIndicator />;
    }

    const chatId = this.state.selectedChat.id;

    return (
      <View full data-test-selector="recent-chatlist" className="RecentMessages">
        <StreamSectionList group={rootGroup} />
        <div className="RecentMessages-content">
          <div className="RecentMessages-content-inner">
            <ConversationView params={{ chatId }} />
          </div>
        </div>
      </View>
    );
  }
}

export default Container.create(RecentMessages);
